import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { Button, Popconfirm } from "antd";
import moment from "moment";

import { PlayIcon } from "../../../../../resource/icons";
import { startVoting } from "../../../store/thunks/voting-states";

import usePlayValidation from "../../../hooks/usePLayValidation";

const PlayButton = ({ selectedAddresses }) => {
	const history = useHistory();
	const voting = useSelector((store) => store.votingStore.voting);
	const { state, title, text, dateStart, dateStop, questions } = voting;
	const dispatch = useDispatch();
	const dateStopIsAfter = moment(voting.dateStop).isAfter(moment(), "minute");
	const dateStartIsAfter = moment(voting.dateStart).isAfter(moment(), "minute");
	const [playConfirmText, setPlayConfirmText] = useState("");
	const [playValidationSuccess, playValidationErrors] = usePlayValidation(
		title,
		text,
		[dateStart, dateStop],
		selectedAddresses,
		questions
	);
	const playingAvailable = dateStopIsAfter && playValidationSuccess;

	useEffect(() => {
		if (playingAvailable) {
			setPlayConfirmText(
				`Запустить опрос? После запуска он станет активным ${
					dateStartIsAfter
						? `${moment(dateStart)?.fromNow()} в ${moment(dateStart).format(
								"HH:mm"
						  )}`
						: "сейчас"
				}`
			);
		} else {
			setPlayConfirmText(
				playValidationErrors || "Дата окончания опроса уже прошла"
			);
		}
	}, [playValidationErrors, playingAvailable, dateStartIsAfter, dateStart]);
	if (state.id === 1) {
		return (
			<Popconfirm
				placement="top"
				title={<div style={{ maxWidth: "300px" }}>{playConfirmText}</div>}
				onConfirm={() => {
					if (playingAvailable) {
						dispatch(startVoting(voting));
					} else {
						history.push(`/Voting/${voting.id}/editing`);
					}
				}}
				okText={playingAvailable ? "Да" : "Изменить опрос"}
				cancelText="Нет"
			>
				<Button
					className={`play button ${playingAvailable ? "" : "play-disabled"}`}
				>
					<PlayIcon />
					<span>Запустить</span>
				</Button>
			</Popconfirm>
		);
	} else {
		return null;
	}
};

export default PlayButton;
